import storage from '../../../../../../../../../hooks/useStorage/useStorage';
import { findBrandUserByContextId } from '../../../../../../../../../services/modules/brandUsers/brandUsers.repository';
import { BrandUser } from '../../../../../../../../../services/modules/brandUsers/brandUsers.types';
import { OfflineDatabaseSeller } from '../../../../../../../database/offlineDatabase/types/offlineDatabaseSeller.types';
import { offlineSellersRepository } from '../../../../../../../repositories/offlineSellers.repository';
import { QueryKeysAndFnOptions } from '../../../useQueryKeysAndFnToCache.types';
import { generateQueryKeysAndFnToPaginatedEndpoint } from '../../generateQueryKeysAndFnToPaginatedEndpoint';
import { QueryKeysAndFnGenerator, QueryKeysAndFnGeneratorParams } from './types';

export class SellersQueryKeysAndFnGenerator implements QueryKeysAndFnGenerator {
  constructor(
    private readonly params: Pick<QueryKeysAndFnGeneratorParams, 'priority' | 'isSeller'>,
  ) {}

  async generateQueryKeysAndFn(): Promise<QueryKeysAndFnOptions> {
    if (this.params.isSeller) {
      return [
        {
          useReactQuery: false,
          priority: this.params.priority,
          queryKey: ['brands/users/:contextId/offline/v1', undefined],
          queryFn: async () => {
            const userContextId = storage.getTeamId();
            const response = await findBrandUserByContextId(userContextId);

            if (!response.ok) {
              throw response.data;
            }
            if (!response.data) {
              return;
            }

            await offlineSellersRepository.save(this.toOfflineData(response.data));
          },
        },
      ];
    }

    const queryKeysAndFnToBrandAdmin = await generateQueryKeysAndFnToPaginatedEndpoint<BrandUser>({
      url: '/brands/users/offline/v1',
      priority: this.params.priority,
      fnToSaveData: async (data) => {
        await offlineSellersRepository.saveAll(data.map(this.toOfflineData));
      },
    });

    return queryKeysAndFnToBrandAdmin;
  }

  private toOfflineData(data: BrandUser): OfflineDatabaseSeller {
    return {
      id: data.userId,
      name: data.name,
      email: data.email,
    };
  }
}
